import api from '@/api'
import config from '@/config'
import { RecoveryPasswordResponse } from '@/types/Auth'
import LogService from './support/LogService'
import { RecoveryPasswordRequest } from '@/types/RecoveryPassword'

async function getRecoveryPasswordMedias (
  domain: string,
  user: string
): Promise<RecoveryPasswordResponse> {
  try {
    const url = `${config.apiUsersUrl}me/recover-password`
    const requestConfig = {
      headers: { 'Content-Type': 'application/json' },
      data: null
    }
    const params = new URLSearchParams([
      ['domain', domain],
      ['user', user]
    ])
    const response = await api.get(url, { params, ...requestConfig })
    return response.data
  } catch (error) {
    LogService.error('Error on getting media recovery: ' + error)
    throw error
  }
}

async function requestRecoveryPasswordPin (
  domain: string,
  user: string,
  grantType: string
) {
  try {
    const url = `${config.apiUsersUrl}me/recover-password`
    const requestConfig = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }
    const params = new URLSearchParams()
    params.append('domain', domain)
    params.append('user', user)
    params.append('grant_type', grantType)
    const response = await api.post(url, params, requestConfig)
    return response.data
  } catch (error) {
    LogService.error('Error on requesting recovery password pin: ' + error)
    throw error
  }
}

async function updatePassword (recoveryPasswordRequest: RecoveryPasswordRequest) {
  try {
    const url = `${config.apiUsersUrl}me/recover-password`
    const configRequest = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }
    const queryParams = new URLSearchParams()
    queryParams.append('domain', recoveryPasswordRequest.domain)
    queryParams.append('user', recoveryPasswordRequest.user)
    queryParams.append('pin', recoveryPasswordRequest.pin)
    queryParams.append('new_password', recoveryPasswordRequest.newPassword)

    const response = await api.put(url, queryParams, configRequest)
    return response.data
  } catch (error) {
    LogService.error('Error on updating password: ' + error)
    throw error
  }
}

const RecoveryPasswordActions = {
  getRecoveryPasswordMedias,
  requestRecoveryPasswordPin,
  updatePassword
}

export default RecoveryPasswordActions
